import React, { useState, useCallback } from 'react'
import cn from 'classnames'
import { useCaptureEventOutsideElement } from '../hooks/useCaptureEventOutsideElement'

const AttributeSelector = ({ attributes, value, onChange, onOpenChange, empty = 'Select...' }) => {
  const [open, setOpen] = useState(false)
  const selectedAttribute = attributes.find((a) => a.id === value)

  const toggleOpen = useCallback(() => {
    const v = !open
    setOpen(v)
    onOpenChange && onOpenChange(v)
  }, [open, onOpenChange])

  const selectOption = useCallback(
    (attribute) => {
      const oldValue = value || []
      const newValue =
        oldValue.indexOf(attribute.id) >= 0 ? oldValue.filter((v) => v !== attribute.id) : [...oldValue, attribute.id]
      onChange(newValue)
    },
    [value]
  )

  const handleClose = useCallback(() => {
    if (!open) return
    setOpen(false)
    onOpenChange && onOpenChange(false)
  }, [open, setOpen, onOpenChange])
  const elemRef = useCaptureEventOutsideElement('click', handleClose)

  return (
    <div ref={elemRef} className={cn('attribute-selector', { open })}>
      <div
        className={cn(
          'attribute-selector-header',
          'padding-horizontal-xs',
          'flex justify-content-space-between align-items-center',
          'background-white',
          'border',
          'font-size-s'
        )}
        onClick={() => toggleOpen()}>
        <div className={cn('all-caps line-height-1', 'margin-right-l', 'no-margin-bottom')}>
          {selectedAttribute ? selectedAttribute.label : empty}
        </div>
        <div className={cn('flex align-items-center gap-x-xs')}>
          <div className={cn('filter-indicator')} style={{ opacity: !open && (value || []).length > 0 ? 1 : 0 }}>
            {(value || []).length}
          </div>
          <svg width="24" height="24" className="display-block">
            <use xlinkHref={`/assets/glyphs/glyphs.svg#${open ? 'chevron-up' : 'chevron-down'}`} />
          </svg>
        </div>
      </div>
      {open && (
        <div
          className={cn(
            'attribute-selector-body',
            'padding-horizontal-xs padding-bottom-xs',
            'background-white',
            'border'
          )}>
          <div className={cn('attributes', 'flex flex-wrap gap-xxs')}>
            {attributes.map((attribute) => (
              <div
                key={attribute.id}
                className={cn(
                  'attribute',
                  (value || []).indexOf(attribute.id) >= 0 && 'selected',
                  attribute.label.length > 20 && 'allow-wrap'
                )}
                onClick={() => selectOption(attribute)}>
                {attribute.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default AttributeSelector
